<template>
    <span
        v-if="loading"
        :class="circle ? ['rounded-full'] : ['rounded']"
        class="animate-slide bg-primary-400 from-primary-400 via-primary-200 to-primary-400 select-none whitespace-nowrap bg-gradient-to-r bg-no-repeat leading-none text-transparent"
    >
        {{ placeholder }}
    </span>
    <slot v-else />
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from 'vue';
import { Logger } from '~/core';
import { useLoadingStore } from '~/stores';

export default defineComponent({
    props: {
        content: {
            type: [String, Number],
        },
        circle: {
            type: Boolean,
        },
        when: {
            type: [String, Array] as PropType<string | string[]>,
        },
    },

    setup(props) {
        if (!props.content && !props.circle) throw new Error('Skeleton: must define content prop or set circle to true');

        const loadingStore = useLoadingStore();
        const skeletonContext = inject<undefined | (() => string[])>('skeletonContext', undefined);

        if (!props.when && !skeletonContext) {
            Logger.warn('Skeleton', 'Detected no context information for when I should be displayed :(');
        }

        return {
            loading: computed(() => {
                if (props.when || skeletonContext) {
                    const map = (data: undefined | string | string[]) => {
                        if (!data) return [];

                        return Array.isArray(data) ? data : [data];
                    };
                    const items = [...map(props.when), ...map(skeletonContext?.())];

                    for (const item of items) {
                        if (loadingStore.isLoading(item)) return true;
                    }

                    return false;
                }

                return loadingStore.isLoading();
            }),

            placeholder: computed(() => {
                if (typeof props.content === 'number') {
                    return '#'.repeat(props.content);
                }

                return props.content;
            }),
        };
    },
});
</script>
